// Asset types
export const SAVED_SCORE = 'saved_score';
export const TALKING_POINT = 'talking_point';
export const WATCHLIST = 'watchlist';
export const SCENARIO = 'scenario';
export const ANALYSIS_PLAN = 'analysis_plan';
export const COMP_TABLE = 'comp_table';
export const TIMESERIES_TABLE = 'timeseries_table';
export const STOCK_SCREENER = 'stock_screener';
export const FUND_SCREENER = 'fund_screener';
export const SCATTER_PLOT = 'scatter_plot';
export const FUND_CHART = 'fund_chart';
export const TECH_CHART = 'tech_chart';
export const DASHBOARD = 'dashboard';
export const PORTFOLIO = 'portfolio';
// Conversion modes
export const FILTER = 'filter';
export const TRANSFORM = 'transform';
